// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","611":"4544e8b5","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"50fee8c20bdb51a1ad63","611":"3824081fa66863fda8e9","678":"d674dc98abae40a2504b","883":"31aa8611b9d152b993ac"}[chunkId] + ".js";
};